// Centralised brand constants
export const BRAND = {
    name: "Quiseo Auto Repair",
    legal: "Quiseo Auto Repair LLC",
    short: "Quiseo",
    tagline: "Mobile Mechanic Service",
    phone: "+1 (720) 995-2682",
    phoneHref: "tel:+17209952682",
    smsHref: "sms:+17209952682",
    email: "service@quiseoautorepair.com",
    address: "Serving Aurora · Parker · Denver · Centennial",
    logo:
        "https://customer-assets.emergentagent.com/job_mechanic-on-wheels-20/artifacts/16atve3c_IMG_3449.jpeg",
};
